import _ from 'lodash';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { HTTP_STATUS_400 } from '../../../services/ApiDataService';
import { handleSaveError } from '../../../services/FormErrorService';

const thresholdValidationErrorText = i18n._(t`There are validation errors on the page`);

export function mapThresholdValidationField(key) {
    const [thresholdId, apiField] = String(key || '').split('.');
    if (_.isEmpty(thresholdId) || _.isEmpty(apiField)) {
        return null;
    }

    const formField = apiField === 'excessive' ? 'critical' : apiField;
    return `byId.${thresholdId}.${formField}`;
}

export function handleThresholdSaveError(errorObject, setError, validationFieldMapper) {
    if (!_.isEmpty(errorObject?.thresholdValidationErrors)) {
        const aggregatedError = _.extend(new Error('Threshold validation failed'), errorObject, {
            getStatus: () => HTTP_STATUS_400,
            responseErrorMessage: thresholdValidationErrorText,
            responseBody: {
                httpCode: HTTP_STATUS_400,
                message: thresholdValidationErrorText,
                details: {
                    errors: errorObject.thresholdValidationErrors,
                },
            },
        });

        return handleSaveError(aggregatedError, setError, validationFieldMapper);
    }

    return handleSaveError(errorObject, setError, validationFieldMapper);
}
